import Vue from 'vue'
import './theme.less'
import ViewUI from 'view-design'
import locale from 'view-design/dist/locale/es-ES'

Vue.use(ViewUI, { locale })